import { useApiMutation } from '@/hooks/useApiMutation';
import { apiPost, operationsClient } from '@/lib/api/client';
import { taxZoneEndpoints } from '@/lib/api/endpoints';
import type { PolygonPreviewRequest, PolygonPreviewZipsResponse } from '@/types/tax-polygon';

/**
 * NOT-99 — Phase A of the split polygon preview.
 *
 * Resolves a drawn polygon to its ZIP list via the lightweight in-memory
 * centroid-containment resolver. Returns sub-second even on populated US
 * metros, so the dialog can transition into the review view immediately
 * and stream the slow rate fetch in via Phase B (`useTaxZonePolygonPreviewRates`).
 *
 * Read-only by design; no cache invalidation.
 */
export function useTaxZonePolygonPreviewZips() {
  return useApiMutation<PolygonPreviewZipsResponse, PolygonPreviewRequest>({
    mutationFn: (data) =>
      apiPost<PolygonPreviewZipsResponse, PolygonPreviewRequest>(
        operationsClient,
        taxZoneEndpoints.previewFromPolygonZips(),
        data,
      ),
    showErrorToast: false,
  });
}
